import { ORDER_TYPES, PRODUCT_NAMES, VAT } from '../config/constants';

export function isInViewport(element, offset = 0) {
  if (! element) return false;
  const top = element.getBoundingClientRect().top;

  return ( top + offset ) >= 0 && ( top - offset ) <= window.innerHeight;
}

const lastScrolledSubmitCounts = new WeakMap();

export function scrollToErrors(props, touchAll = false) {
  const { submitCount, isValidating, errors } = props;
  const keys = Object.keys( errors );
  const lastScrolledSubmitCount = lastScrolledSubmitCounts.get( props.setTouched ) || 0;

  if (submitCount === 0 || isValidating || keys.length === 0) {
    return;
  }

  if (submitCount <= lastScrolledSubmitCount) {
    return;
  }

  lastScrolledSubmitCounts.set( props.setTouched, submitCount );

  if (touchAll) {
    const allTouched = {};
    Object.keys( props.initialValues ).forEach( key => {
      allTouched[key] = true;
    } );
    props.setTouched( allTouched, false );
  }

  const delay = touchAll ? 300 : 100;

  setTimeout( () => {
    const elements = document.getElementsByClassName( 'field-error' );

    if (elements.length === 0) {
      return;
    }

    for (let i = 0; i < elements.length; i++) {
      if (! isInViewport( elements[i] )) {
        elements[i].scrollIntoView( { behavior: "smooth", block: "center" } );
        return;
      }
    }
  }, delay );
}

export function transformBytesInKb(bytes) {
  return `${parseFloat(bytes / 1024).toFixed(2)} KB`
}

export function calculateTotalPriceOnCustomOrder(number, value) {
  let total = !isNaN(number * value) ? (number * value) : 0.00;
  total = (total + (total * VAT)).toFixed(2);

  return total;
}

export function calculatePriceWithoutVat(nrOfProducts, value) {
  return (nrOfProducts * value).toFixed(2);
}

export function calculateVatValue(nrOfProducts, value) {
  return (calculatePriceWithoutVat(nrOfProducts, value) * VAT).toFixed(2);
}

export function calculateTotalPriceOnCustomOrderWithoutVat(number, value) {
  let total = !isNaN(number * value) ? (number * value) : 0.00;

  return total.toFixed(2);
}

export function getCustomOrderProduct(productGroup) {
  let product;
  productGroup.products.forEach(p => {
    if (p.name === PRODUCT_NAMES.CUSTOM_ORDER) {
      product = p;
    };
  });

  return product;
}

export const getOrderTypeByValue = (type) => {
  let name;

  Object.keys(ORDER_TYPES).forEach(key => {
    if(ORDER_TYPES[key].value === type) {
      name = ORDER_TYPES[key].label;
    }
  });

  return name;
}

export const urlBase64ToUint8Array = (base64String) => {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const formatVatPercentage = (vatDecimal) => {
  if (!vatDecimal || vatDecimal === 0) return '0';

  if (vatDecimal > 1) return Math.round(vatDecimal);

  return Math.round(vatDecimal * 100);
};
